export const authEndpoint = {
    // Autenticação
    login: `/api/v1/auth/token`,
    loginDoisFatores: `/api/v1/auth/token/2fa`,
    refreshToken: `/api/v1/auth/refresh-token`,
    confirmarSenha: `/api/v1/auth/confirma-senha`,

    // Auto Cadastro
    obterTokenAutoCadastro: `/api/v1/auth/auto-token`,

    // ReCAPTCHA
    verificarRecaptcha: `/api/v1/auth/recaptcha-token`,
}
